import React from "react";
import { FormProvider } from "react-hook-form";
import { Create } from "@refinedev/mui";

import { AgreementForm } from "@modules/agreements/components/AgreementForm";
import { useAgreementCreateForm } from "./controller";

export const AgreementCreate = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending } = useAgreementCreateForm();

  return (
    <Create
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
    >
      <FormProvider {...methods}>
        <AgreementForm />
      </FormProvider>
    </Create>
  );
});
